import React, { FC } from 'react';
import EventCharts from '@components/machines/components/eventsChart';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { getPartByID } from '@reducers/parts';
import Paid from '@components/ncFiles/components/paid';

interface PartDetailsNCFilePerformancePaidProps {}

const PartDetailsNCFilePerformancePaidComponent: FC<PartDetailsNCFilePerformancePaidProps> = ({
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    operationsSearch,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <EventCharts getContentElement={(props) => <Paid {...props} />} />
    </DetailsPageWrapper>
  );
};

const PartDetailsNCFilePerformancePaid = connect(null, {
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsNCFilePerformancePaidComponent);

export { PartDetailsNCFilePerformancePaid };
